import axios from "axios";
import serverConfig from "../config/serverConfig";
import getSessionCode from "../utils/sessionCode";

const apiClient = axios.create({
  baseURL: serverConfig.url,
  //timeout: 5000, // timeout limit 
  headers: {
    "Content-Type": "application/json",
  },
});

/** Axios Interceptors */

// Request interceptor (adding auth tokens to the request if needed)
apiClient.interceptors.request.use(
  (config) => {
    config.headers["X-Session-Code"] = getSessionCode();
    // config.headers.Authorization = `Bearer ${yourAuthToken}`;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor (error handling)
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      if (error.response.status === 401) {
        console.error("Unauthorized! Redirecting...");
        // Redirect to login page
      } else if (error.response.status === 500) {
        console.error("Server error! Try again later.");
      }
    } else if (error.request) {
      console.error("No response from server! Check internet connection.");
    } else {
      console.error("Request error:", error.message);
    }
    return Promise.reject(error);
  }
);

export default apiClient;
